module.exports = __webpack_public_path__ + "static/media/checkin-card-reader-b.7231c522.png";